import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import SelectedLandmarkForm from "./SelectedLandmarkForm";
import { useSharedActions, useSharedDispatch, useSharedSelector } from "../../../../store/SharedProvider";
import {
  selectSelectedLandmark,
  selectZonePlannerMouseState,
} from "../../../../store/room/zone-planner/zone-planner-selectors";
import ZoneControllerMouseState from "../../../../enums/robot/zone-planner/zone-controller-mouse-state";

const SelectedLandmarkControls: React.FC = () => {
  const { t } = useTranslation();
  const matchesMdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  const dispatch = useSharedDispatch();

  const { setSelectedLandmark } = useSharedActions();

  const selectedLandmark = useSharedSelector((state) => selectSelectedLandmark(state));
  const zonePlannerMouseState = useSharedSelector((state) => selectZonePlannerMouseState(state));

  if (zonePlannerMouseState !== ZoneControllerMouseState.Default || selectedLandmark == null) {
    return null;
  }

  const handleContentDialogClose = () => {
    dispatch(setSelectedLandmark(null));
  };

  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="body1">{`${t("landmark-point-name-" + selectedLandmark.type)}: ${
          selectedLandmark.name
        }`}</Typography>
      </Grid>
      <Grid item xs={12}>
        <SelectedLandmarkForm landmark={selectedLandmark} key={selectedLandmark.id} />
      </Grid>
    </Grid>
  );
  return (
    <React.Fragment>
      {matchesMdUp ? (
        <Card
          sx={(theme) => ({
            position: "absolute",
            right: 0,
            zIndex: 2,
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(10),
            width: theme.spacing(48),
            overflow: "auto",
            maxHeight: `calc(100% - ${theme.spacing(2)})`,
          })}
        >
          <CardContent>{content}</CardContent>
        </Card>
      ) : (
        <Dialog open={true} onClose={handleContentDialogClose} fullWidth maxWidth="xs">
          <DialogContent>{content}</DialogContent>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export default SelectedLandmarkControls;
